
    import { Mapper } from "../../../../base/utils/mapper";
    import { DevelopmentNeuropsychologyResponseModel } from "../../../../domain/models/consult/development-neuropsychology-response.model";
    import { DevelopmentNeuropsychologyResponseEntity } from "../entities/development-neuropsychology-response.entity";


    export class DevelopmentNeuropsychologyImplementationRepositoryMapper extends Mapper<DevelopmentNeuropsychologyResponseEntity, DevelopmentNeuropsychologyResponseModel>{
        mapFrom(param:  DevelopmentNeuropsychologyResponseEntity):  DevelopmentNeuropsychologyResponseModel { 
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors
            }; 
        }
        mapTo(param:  DevelopmentNeuropsychologyResponseModel):  DevelopmentNeuropsychologyResponseEntity {
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors 
            };
        }
    }